<app-loading-overlay [isLoading]="joinCLub" class="dialog-fill">
  <bv-dialog-title>{{ "JOIN_EXISTING_CLUB" | translate }}</bv-dialog-title>
  <bv-dialog-body>
    @if (foundClub) {
      <div class="flex flex-row items-center gap-4">
        <img
          [src]="foundClub.logoURL || '/assets/img/club-no-logo.png'"
          class="club-image flex-shrink-0"
          />
        <div class="flex flex-col min-w-0">
          <h1 class="break-words">{{ foundClub.clubName }}</h1>
          <p>{{ foundClub.clubID }}</p>
        </div>
      </div>
    }
    <form #joinClubForm="ngForm">
      <div class="flex-1 flex flex-col">
        <bv-form-field label="{{ 'ENTER_CLUB_ID' | translate }}">
          <div style="width: 120px">
            <input
              bv-input
              type="text"
              [ngModel]="clubID"
              name="clubID"
              required
              (ngModelChange)="clubIDChange($event)"
              minlength="4"
              maxlength="4"
              />
          </div>
        </bv-form-field>
      </div>
    </form>
  </bv-dialog-body>
  <bv-dialog-footer>
    <app-close-dialog-button label="{{ 'CANCEL' | translate }}"></app-close-dialog-button>
    <button
      id="btn_join_club_send_request"
      bv-button variant="primary"
      (click)="sendJoinRequest()"
      [disabled]="!foundClub"
      >
      {{ "SEND_REQUEST" | translate }}
    </button>
  </bv-dialog-footer>
</app-loading-overlay>
